import React, { Fragment } from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardHeader,
  CardImg,
  Col,
  Row,
  Table,
  Button,
} from "reactstrap";
import { MdEdit } from "react-icons/md";

import Page from "../components/Page";
import PrayerTimeBannersEdit from "./PrayerTimeBannersEdit";
import PageSpinner from "../components/PageSpinner";

import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";
import * as GeneralFunctions from "../GeneralFunctions";

class PrayerTimeBanners extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prayerTimeBanner: {},
      prayerTimeBanners: [],
      showLoader: false,
      editPrayerTimeBanner: false,
      prayerTimeBannerEditPage: false,
    };
  }

  componentDidMount() {
    this.getPrayerPageDetails();
  }

  getPrayerPageDetails = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "prayerPage/details",
        method: "GET",
      });
      if (response) {
        let keys = response.details.prayerBackgroundBannerUrls
          ? Object.keys(response.details.prayerBackgroundBannerUrls)
          : [];
        this.setState({
          showLoader: false,
          prayerTimeBanners: keys.map((key) => ({
            name: key,
            banners: response.details.prayerBackgroundBannerUrls[key],
          })),
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderPrayerTimeBannersEditPage = (prayerTimeBanner, key) => {
    this.setState({
      prayerTimeBanner,
      prayerTimeBannerEditPage: true,
      editPrayerTimeBanner: key,
    });
  };

  closePrayerTimeBannersEditPage = async (obj) => {
    this.setState({ prayerTimeBannerEditPage: false });
    if (obj.refreshList) {
      this.getPrayerPageDetails();
    }
  };

  render() {
    return (
      <Fragment>
        {this.state.prayerTimeBannerEditPage ? (
          <PrayerTimeBannersEdit
            prayerTimeBanner={this.state.prayerTimeBanner}
            editPrayerTimeBannerKey={this.state.editPrayerTimeBanner}
            closePrayerTimeBannersEditPage={(event) =>
              this.closePrayerTimeBannersEditPage(event)
            }
          ></PrayerTimeBannersEdit>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page
              title="Prayer Time Banners"
              breadcrumbs={[{ name: "Prayer Time Banners", active: true }]}
            >
              <Row>
                <Col>
                  <Card className="mb-3">
                    <CardHeader></CardHeader>
                    <CardBody>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Banner</th>
                            <th>Moon/Sun Arc</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.prayerTimeBanners &&
                          this.state.prayerTimeBanners.length > 0 ? (
                            this.state.prayerTimeBanners.map(
                              (prayerTimeBanner, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.30)",
                                  }}
                                >
                                  <td>
                                    {GeneralFunctions.capitalizeFirstLetter(
                                      prayerTimeBanner.name
                                    )}
                                  </td>
                                  <td style={{ width: "25%" }}>
                                    <CardImg
                                      key={index}
                                      src={prayerTimeBanner.banners[0]}
                                      alt=""
                                    />
                                  </td>
                                  <td style={{ width: "25%" }}>
                                    <CardImg
                                      key={index}
                                      src={prayerTimeBanner.banners[1]}
                                      alt=""
                                    />
                                  </td>
                                  <td>
                                    <Button
                                      style={{ marginRight: "10px" }}
                                      onClick={(event) => {
                                        this.renderPrayerTimeBannersEditPage(
                                          prayerTimeBanner,
                                          true
                                        );
                                      }}
                                    >
                                      <MdEdit size="20px" />
                                    </Button>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No banners found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}
export default PrayerTimeBanners;
